import { Map } from 'immutable';

/**
 * ContentUtils
 * utility functions that take some form of content (stations, tracks, playlists, albums, etc)
 * and return something based on type evaluations.
 *
 * @module lib/ContentUtils
 */

/**
 * @param  {Immutable#Map} content - an immutable map
 * @returns {string} - url for content's backstage page
 */
// UNUSED
export function getBackstageRouteForContent(content: $TSFixMe): string {
  const baseUrl = '/artist/';
  if (!(content instanceof Map)) {
    return '#';
  }
  // @ts-expect-error TS(2339) FIXME: Property 'get' does not exist on type '{}'.
  if (content.get('stationId')) {
    // @ts-expect-error TS(2339) FIXME: Property 'get' does not exist on type '{}'.
    return baseUrl + `station/${content.get('stationId')}`;
  }
  return '#';
}
